function QueryParser(window) {
    var self = this;

    this.parse = function(queryString) {
        if (queryString.length === 0) {
            return {};
        }
        if (queryString[0] === "?") {
            queryString = queryString.substr(1);
        }

        return queryString.split('&').reduce(function(previous, current) {
            var myArray = current.split("=");
            previous[myArray[0]] = decodeURIComponent(myArray[1]);
            return previous;
        }, {});
    };

    this.parseFromCurrentUrl = function() {
        return self.parse(window.location.search);
    };
}

module.exports = {
    init: function(window) {
        return new QueryParser(window);
    }
};